import {createSelector} from 'reselect';

const ticketsSelector = (state) => state && state.tickets || {};
const ticketSectionSelector = createSelector(ticketsSelector, (tickets) => tickets.section || null);

export {
  ticketSectionSelector
};
